import {
  capacityCheckResultSchema,
  type CapacityCheckInput,
  type CapacityCheckResult,
} from '@tailoring-crm/shared';
import type { ApiClient } from '../api/client.js';

/**
 * The one capacity call the app makes: "can we deliver by this date?".
 *
 * A POST that changes nothing. The route is read-only — see `capacity.routes.ts` — and is a POST
 * only because fifty proposed tasks with five fields each do not belong in a query string. There
 * is no create, no update and no delete here because the module behind it stores nothing at all:
 * every number on the answer is derived at request time from the roster, the shop's stages and
 * the assignments already open.
 *
 * EVERY DURATION ON THE WIRE IS WHOLE MINUTES. Hours are a thing the screen collects and the
 * screen converts; nothing between here and the database has ever seen a fractional hour.
 */

const CAPACITY = '/capacity';

export async function checkCapacity(
  client: ApiClient,
  input: CapacityCheckInput,
): Promise<CapacityCheckResult> {
  return await client.post(`${CAPACITY}/check`, input, { schema: capacityCheckResultSchema });
}
